// import React from 'react'

// import HeaderJSON from './Header.json'
// import { IoNotificationsCircleOutline } from 'react-icons/io5'
// import { Badge } from '@mui/material'

// export default function Header () {
//   return (
//     <div className='bg-white border-b border-black/10 flex h-16 items-center justify-between px-4 relative z-10 flex-shrink-0'>
//       <div className='flex items-center w-72 '>
//         <div className='hidden xl:block '>
//           <img
//             src='/icons8-system-administrator-female-100.png'
//             alt='Admin Avatar'
//             className='rounded-full mr-4'
//             width={30}
//           />
//         </div>
//         <div className='ml-20 xl:ml-0 xl:flex items-center text-lg font-semibold'>
//           {HeaderJSON['Admin-name']}
//         </div>
//       </div>

//       <div>
//         <Badge overlap='circular' variant='dot' color='error'>
//           <IoNotificationsCircleOutline color='primary' />
//         </Badge>
//       </div>
//     </div>
//   )
// }

import React, { useState, useRef, useEffect } from 'react'
import HeaderJSON from './Header.json'

import { FaChevronDown } from 'react-icons/fa'
import { confirmAlert } from 'react-confirm-alert'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '../../redux/slices/userSlice'
import { showSuccessToast } from '../Toast/Toast'

export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const logoutConfirmed = () => {
    dispatch(logout());
    showSuccessToast("You have logged out successfully!");
    navigate('/login');
  };
  const handleLogOut = () => {
    confirmAlert({
      title: 'Confirm Logout',
      message: 'Are you sure you want to logout?',
      buttons: [
        { label: 'Yes', onClick: logoutConfirmed },
        { label: 'No' }
      ]
    })
  }
  return (
    <div className='bg-white  border-black/10 flex h-16 items-center justify-between px-4 relative z-10 flex-shrink-0'>
      {/* Left Section */}
      <div className='flex items-center w-72 '>
        <div className='hidden xl:block '>
          <img
            src='/icons8-system-administrator-female-100.png'
            alt='Admin Avatar'
            className='rounded-full mr-4'
            width={30}
          />
        </div>
        <div className='ml-20 xl:ml-0 xl:flex items-center text-lg font-semibold'>
          {HeaderJSON['Admin-name']}
        </div>
      </div>

      {/* Right Section */}
      <div className='flex items-center gap-6'>
   
        <div className='relative' ref={dropdownRef}>
          <button
            className='flex items-center gap-2 border rounded-md px-3 py-1  transition'
            onClick={() => setDropdownOpen(prev => !prev)}
          >
            <img
              src='/profile.png'
              alt='Profile'
              className='w-8 h-8 rounded-full'
            />
            <FaChevronDown size={12} className='text-gray-600' />
          </button>

          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div className='absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50'>
              <ul className='py-1 text-sm text-gray-700'>
                {/* <li className='px-4 py-2 hover:bg-[#e3ebf7] cursor-pointer'>
                  Update Password
                </li>
                <li className='px-4 py-2 hover:bg-[#e3ebf7] cursor-pointer'>
                  Settings
                </li> */}
                <li
                  className="px-4 py-2.5 rounded-lg hover:bg-black hover:text-white cursor-pointer font-medium transition-all duration-200 ease-in-out flex items-center gap-2 active:scale-95 group"
                  onClick={() => handleLogOut()}
                >
                  <svg
                    className="w-5 h-5 text-gray-500 group-hover:text-white transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    ></path>
                  </svg>
                  <span>Logout</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
